export const heroSchema = `{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "AG1",
  "alternateName": [
    "AG1 by Athletic Greens",
    "Athletic Greens",
    "AG1 Greens",
    "AG1 Athletic Greens"
  ],
  "description": "AG1 (formerly Athletic Greens) is a global health and wellness company which produces a daily Foundational Nutrition supplement that supports whole body health.",
  "url": "https://drinkag1.com/",
  "knowsAbout": [
    "health",
    "wellness",
    "supplements",
    "greens"
  ],
  "logo": "https://pbs.twimg.com/profile_images/1697387171769204736/Ch5QrZxb_400x400.jpg",
  "foundingDate": "2010",
  "email": "support@drinkag1.com",
  "telephone": "+1-888-390-4029",
  "funder": [
    "Alpha Wave Global",
    "Mark Vadon",
    "SC.Holdings",
    "Bolt Ventures",
    "Peter Attia"
  ],
  "hasCertification": [
    "TGA Certification",
    "NSF Certification for Sport",
    "Climate Neutral Certification"
  ],
  "keywords": [
    "AG1",
    "AG1 by Athletic Greens",
    "Athletic Greens",
    "AG1 Greens",
    "AG1 Athletic Greens",
    "AG1 Reviews",
    "AG1 Review",
    "Athletic Greens Reviews",
    "Athletic Greens Review"
  ],
  "subOrganization": [
    "AG1 (USA), Inc.",
    "AG1 (Europe) Limited",
    "AG1 (International) Limited"
  ],
  "sameAs": [
    "https://www.instagram.com/drinkag1/",
    "https://www.facebook.com/drinkAG1/",
    "https://twitter.com/drink_AG1",
    "https://www.tiktok.com/@drinkag1",
    "https://www.youtube.com/@drinkAG1",
    "https://www.linkedin.com/company/drink-ag1",
    "https://www.indeed.com/cmp/Athletic-Greens",
    "https://www.google.com/search?kgmid=/g/11v42pk6k8"
  ],
  "mainEntityOfPage": [
    "https://drinkag1.com/about-ag1/reviews/ctr",
    "https://www.nytimes.com/2022/07/08/dining/athletic-greens.html",
    "https://www.forbes.com/sites/forbes-personal-shopper/2023/02/28/athletic-greens-review/",
    "https://www.vogue.com/article/best-greens-powder",
    "https://www.bonappetit.com/story/best-greens-powder",
    "https://www.goodhousekeeping.com/health-products/a46883816/athletic-greens-review/",
    "https://theeverygirl.com/athletic-greens-review/",
    "https://www.youtube.com/watch?v=AYQCz0DQ5So",
    "https://www.youtube.com/watch?v=dtu7_f3UXsE",
    "https://www.bloomberg.com/profile/company/1904926D:US",
    "https://www.crunchbase.com/organization/athletic-greens",
    "https://pitchbook.com/profiles/company/268771-06",
    "https://theorg.com/org/athletic-greens",
    "https://techcrunch.com/2022/01/25/athletic-greens-valued-at-1-2b-nutrition-drink/",
    "https://news.crunchbase.com/venture/nutrition-startup-athletic-greens-ag1-vc-funding-unicorn/",
    "https://www.businesswire.com/news/home/20211215005262/en/Athletic-Greens-Names-Kat-Cole-as-President-and-Chief-Operating-Officer",
    "https://www.businesswire.com/news/home/20220125005425/en/Athletic-Greens-Raises-115M-From-Alpha-Wave-Ventures-and-Strategic-Investors-to-Accelerate-Global-Growth-and-Reach-Millions-of-New-Customers",
    "https://www.businesswire.com/news/home/20220927005253/en/Athletic-Greens-Names-Dr.-Ralph-Esposito-Head-of-Nutrition",
    "https://www.bloomberg.com/news/articles/2024-07-24/green-drink-specialist-ag1-names-cole-ceo-succeeding-ashenden",
    "https://www.businessoffashion.com/news/beauty/ag1-names-new-chief-executive/",
    "https://www.businesswire.com/news/home/20240724419348/en/AG1-Names-Kat-Cole-Chief-Executive-Officer"
  ],
  "employee": {
    "@type": "Person",
    "name": "Kat Cole",
    "givenName": "Kat",
    "familyName": "Cole",
    "alternateName": "Katrina Cole",
    "image": "https://en.wikipedia.org/wiki/Kat_Cole#/media/File:KatCole_Steph_Grant-30.jpg",
    "gender": "Female",
    "description": "Kat Cole is a seasoned executive and leader with deep expertise building global brands, consumer businesses, and high-performing teams. Kat serves as the CEO & Board of Directors at AG1.",
    "hasOccupation": "Business executive and thought leader",
    "jobTitle": "CEO & Board of Directors at AG1",
    "worksFor": "AG1",
    "knowsAbout": [
      "health",
      "wellness",
      "supplements",
      "greens"
    ],
    "nationality": "United States of America",
    "birthPlace": "Jacksonville, Florida",
    "birthDate": "1978-03-18",
    "alumniOf": "Georgia State University",
    "homeLocation": "Atlanta, Georgia",
    "workLocation": "Atlanta, Georgia",
    "knowsLanguage": "English",
    "sameAs": [
      "https://www.linkedin.com/in/katcole",
      "https://twitter.com/katcoleatl",
      "https://www.instagram.com/katcoleatl/",
      "https://katcole.substack.com/",
      "https://www.facebook.com/kat.cole/",
      "https://www.google.com/search?kgmid=/m/011smzrr"
    ],
    "mainEntityOfPage": [
      "https://en.wikipedia.org/wiki/Kat_Cole",
      "https://www.wikidata.org/wiki/Q17859762",
      "https://en.wikiquote.org/wiki/Kat_Cole",
      "https://www.crunchbase.com/person/kat-cole",
      "https://www.imdb.com/name/nm5441940/",
      "https://www.wsb.com/speakers/kat-cole/",
      "https://fortune.com/2023/11/01/kat-cole-athletic-greens-coo-hooters-hotshot-rule/",
      "https://fortune.com/videos/watch/kat-cole-went-from-hooters-waitress-to-athletic-greens-coo-without-a-bachelor%E2%80%99s-degree.-she-credits-a-simple-exercise%E2%80%94the-%E2%80%98hotshot-rule%E2%80%99%E2%80%94for-her-rise/2c9cad36-86b5-472e-b592-b6ecd4ea7870",
      "https://www.businesswire.com/news/home/20211215005262/en/Athletic-Greens-Names-Kat-Cole-as-President-and-Chief-Operating-Officer",
      "https://www.beautyindependent.com/athletic-greens-names-kat-cole-turned-cinnabon-1b-brand-president-coo/",
      "https://www.youtube.com/watch?v=rVkOaNvyw8Q",
      "https://www.youtube.com/watch?v=fdu7XQSdmR0",
      "https://www.youtube.com/watch?v=CTbVSzjG7h8",
      "https://www.bloomberg.com/news/articles/2024-07-24/green-drink-specialist-ag1-names-cole-ceo-succeeding-ashenden",
      "https://www.businessoffashion.com/news/beauty/ag1-names-new-chief-executive/",
      "https://www.businesswire.com/news/home/20240724419348/en/AG1-Names-Kat-Cole-Chief-Executive-Officer"
    ]
  }
}`;
